import {IShow3dVisualizer, IVisualizerManager} from "./VisualizerContext";
import {IActorTrigger} from "../unreal/BigScreenWebPage";
import {IShow3DOptions} from "../components/visualizer/VisualizerSessionManager";
import * as signalR from "@microsoft/signalr";
import {HttpTransportType, HubConnection} from "@microsoft/signalr";
import {IOptionSetRequest} from "../unreal_api/UnrealClient";
import IVscCommunityMapInfo from "./IVscCommunityMapInfo";
import {IViewpoint} from "../data/IViewpoint";


function shortenActorTrigger(trigger:IActorTrigger) {
    let rval = `${trigger.C}/${trigger.T}/${trigger.F}`
    if (trigger.P !== undefined && trigger.P.length > 0) {
        rval += `/${trigger.P.join("|")}`;
    }
    return rval;
}


function shortenActorTriggers(trigger:IActorTrigger[]) {
    return trigger.map(t => shortenActorTrigger(t)).join("!");
}
export interface IMessageSender {
    sendMessage(msg: unknown):void;

}
export class UnrealSignalRVisualizerManager implements IVisualizerManager, IShow3dVisualizer, IMessageSender {

    private connection: HubConnection|undefined;
    private readonly recipient:string;

    getMessageSender(): IMessageSender {
        return this;
    }

    constructor(private readonly serverUri: string, private readonly salesCenterId:string, private readonly stationId:string, private readonly token:string) {
        this.recipient = `${salesCenterId} ${stationId}`;

    }
    private connectionPromise: Promise<void>|undefined;

    connect() {
        if (this.connectionPromise !== undefined) {
            return this.connectionPromise;
        }
        const uri = `${this.serverUri}-/hub`;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(uri, { transport: HttpTransportType.LongPolling })
            .withAutomaticReconnect()
            .build();
        this.connectionPromise = this.connection.start();
        const w = window as any;
        if (w) {
            w.signalRConnection = this.connection;
        }

        return this.connectionPromise;

    }


    async verifyConnection(): Promise<string | null> {

        return null;
    }

    changeCamera(cameraId: string) {
        if (this.connection === undefined) throw "Not connected!";
        //const body = "value=" + encodeURIComponent(cameraId).replace(/%20/g, "+");
        this.connection.send("unrealMessage", {
            type: "ChangeCamera",
            recipient: this.recipient,
            content: cameraId
        });
    }

    changeCameraToViewpoint(viewpoint: IViewpoint) {

    }

    sendMessage(msg: unknown) {
        if (this.connection === undefined) throw "Not connected!";
        this.connection.send("unrealMessage", {
            recipient: this.recipient,
            type: "MediaCanvas",
            content: JSON.stringify(msg)
        })
    }

    async browse(stateIndex: string, uri: string) {
        const parsedUrl = new URL(uri);
        const authDomain = parsedUrl.origin;

        console.log('browsing to ' + uri);
        await this.sendMessage({Id: stateIndex, Command: "Browse", Url: uri, Auth: this.token, AuthDomain: authDomain});

    }

    async show3d(sessionId: string, options: IShow3DOptions) {

        const actorTriggers: IActorTrigger[] = [];

        if (options.houseModels !== undefined) {
            for (const hm of options.houseModels) {
                actorTriggers.push({
                    C: "",
                    T: hm.lotId,
                    F: "SetHouseModel",
                    P: [`HouseModel=${hm.houseModel}`]
                });
            }
        }

        if (options.levelGroups) {

            for (const lg of options.levelGroups) {
                actorTriggers.push({
                    C: "",
                    T: lg.lot,
                    F: "SetLevelGroup",
                    P: [`LevelGroupName=${lg.levelGroup}`]
                });

            }
        }
        if (options.lotLabels) {
            for (const lb of options.lotLabels) {
                actorTriggers.push({
                    C: "",
                    T: lb.lot,
                    F: "SetStatusText",
                    P: [`TextValue=${lb.label}`, `Color=${lb.color}`]
                })
            }
        }
        if (options.parking) {
            for (const p of options.parking) {
                if (!p.show) continue;

                actorTriggers.push({
                    C: "DXLotParking",
                    T: p.lot,
                    F: p.show ? "SetToStar" : "ClearAll",
                    P: []
                });
            }
        }
        const msg = {
            Id: sessionId,
            Command: "ThreeDC",
            ActorTriggers: shortenActorTriggers(actorTriggers)
        }
        await this.sendMessage(msg);
        return true;
    }


    async playVideo(sessionId:string, file: string, looping: boolean) {


        const msg = {
            Id: sessionId,
            Command: "VideoPlay",
            Video: (file.startsWith("http://") || file.startsWith("https://")) ? file : ("./Movies/" + file)
        } as any;

        if (looping) {
            msg.Loop = true;
        }
        await this.sendMessage(msg);
    }

    sendOptions(req: IOptionSetRequest): void {
        if (this.connection === undefined) throw "Not connected!";
        this.connection.send("unrealMessage", {
            type: "SendOptionSet",
            recipient: this.recipient,
            content: JSON.stringify(req)
        });
    }

    requestMapInfo(): Promise<IVscCommunityMapInfo> {
        if (this.connection === undefined) throw "Not connected!";

        this.connection.send("unrealMessage", {
            type: "MapInfo",
            recipient: this.recipient
        });
        return Promise.reject();
    }
}

